import { gql, useMutation } from "@apollo/client";
import { useCallback } from "react";
import { HandleRebateMutation, HandleRebateInput } from "@/gql/graphql";
import { rebateOverviewQuery } from "./UseRebateOverview";

const mutation = gql`
  mutation HandleRebate($input: HandleRebateInput!) {
    productPrice {
      rebate {
        handleRebate(input: $input)
      }
    }
  }
`;

export const useHandleRebate = () => {
  const [mutate, { loading, error, data }] = useMutation<HandleRebateMutation>(
    mutation,
    {
      refetchQueries: [rebateOverviewQuery, "RebateOverviewFetcher"],
    }
  );

  const handleRebate = useCallback(
    (input: HandleRebateInput) => {
      return mutate({ variables: { input } });
    },
    [mutate]
  );

  return {
    handleRebate,
    loading,
    error,
    success: !!data,
  };
};
